import React, { PureComponent } from 'react';
import Dropdown from '../standardAttributes/Dropdown';

export default class Depth extends PureComponent {
  onChange = async (ev, { value }) => {
    const {
      attributeName,
      configuration,
      actions,
      setAppState,
      getAppState,
      appApi,
      activeTab,
    } = this.props;
    if (value === configuration[attributeName].value) return;

    let newAppState = getAppState();
    if (configuration.base.modelId)
      newAppState = actions.removeModel(
        configuration.base.modelId,
        newAppState
      );

    const base = configuration.base.value;
    const { width } = appApi.config.getDefaultBaseProduct(base, value);
    const { sceneId, name } = appApi.config.getBaseProduct(base, value, width);
    const blocksData = appApi.config.getProductBlockData('base', name);
    setAppState({ disabled: true });
    const importState = await appApi.model.importModel(sceneId, { blocksData });
    newAppState = actions.addModel(
      importState,
      {
        tab: activeTab,
        attribute: 'base',
        value: name,
      },
      newAppState
    );
    newAppState = actions.setConfiguration(
      [
        {
          attribute: 'base',
          value: { ...configuration.base, ...importState },
        },
        { attribute: attributeName, value: { value } },
        { attribute: 'width', value: { value: width } },
      ],
      newAppState
    );
    setAppState(newAppState);
  };

  render() {
    const { configuration, appApi } = this.props;
    const options = appApi.config.getAvailableDepth(configuration);
    return (
      <Dropdown {...this.props} options={options} onChange={this.onChange} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Attributes/nonStandardAttributes/Depth.js